import _uniqueId from "lodash-es/uniqueId";
import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { parseAddress, parseName, parsePhones } from '../utils';
import { Phones } from './PatientElements';
import { CAREGIVER_ROLE, CAREGIVER_ROLES } from '../constants';
export const Caregivers = ({
  caregivers
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, `${defaults.careGivers}`), Array.isArray(caregivers) ? caregivers.map(caregiver => /*#__PURE__*/React.createElement(Caregiver, {
  caregiver: caregiver,
  key: _uniqueId('caregivers-')
})) : /*#__PURE__*/React.createElement(Caregiver, {
  caregiver: caregivers
}));

var _ref = /*#__PURE__*/React.createElement(View, null);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

const Caregiver = ({
  caregiver
}) => {
  const {
    city,
    state,
    street,
    zip
  } = parseAddress(caregiver);
  const phones = parsePhones(caregiver);
  const name = parseName(caregiver);
  const roleData = caregiver[CAREGIVER_ROLES] && caregiver[CAREGIVER_ROLES][CAREGIVER_ROLE];
  const roles = roleData && (roleData.name || roleData.map(role => ` ${role.name}\n`));
  const relation = String(caregiver.relation).toUpperCase();
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.width100]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.width20, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, name)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width12, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, street)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, city)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, `${state} ${zip}`)), caregiver.relation ? /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, `${relation}`)) : _ref, /*#__PURE__*/React.createElement(View, {
    style: [styles.width20, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, roles)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width15, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, phones ? /*#__PURE__*/React.createElement(Phones, {
    phones: phones
  }) : _ref2)));
};